import React from 'react';
import { InputNumber } from 'antd';
import { toEuro } from '../../utils/utils';
import { InputNumberProps } from 'antd/lib/input-number';

export type InputMoneyProps = InputNumberProps;

const InputMoney = (props: InputMoneyProps) => {
  return (
    <InputNumber
      onKeyPress={(event) => {
        if (!/([0-9 . ,])/.test(event.key)) {
          event.preventDefault();
        }
      }}
      formatter={toEuro}
      parser={(value) => value?.replace('€', '').replace(',', '') ?? ''}
      {...props}
    />
  );
};

export default InputMoney;
